/* eslint-disable react/no-multi-comp */
import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { Link } from "gatsby"
import { Headline, Eyebrow, CTA, GridLines, Analytics } from "@shared"
import { css } from "@jsUtils"
import { URLS } from "@data"

import { PageSection } from "../PageSection"

import Styles from "./ourPeople.module.scss"

const TrackLink = Analytics(Link)

const PersonCard = props => {
  const { person } = props
  return (
    <TrackLink
      ascope="CTAS"
      adata="MISC.PEOPLE"
      to={`${URLS.LEADERSHIP}${person.slug}/`}
      className={Styles.person}
      key={person.slug}
    >
      <div className={Styles.portraitWrapper}>
        <Img alt={person.photo.title} className={Styles.portrait} fluid={person.photo.fluid} />
      </div>
    </TrackLink>
  )
}

/**
 * Our People Section
 * @param {object} props - React props
 */
const OurPeople = props => {
  const { color, theme, people } = props
  const [ready, setReady] = React.useState(false)
  return (
    <PageSection
      className={css(Styles.section, Styles[`theme_${theme}`], ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>
        <div className={Styles.leftHalf}>
          <div className={Styles.copy}>
            <Eyebrow className={Styles.eyebrow} color={color}>
              People
            </Eyebrow>
            <Headline className={Styles.headline} size={2}>
              Meet the Team
            </Headline>
            <p className={Styles.description}>
              We have dedicated our lives to conquering difficult engineering challenges and making
              thoughtful and complex decisions that has brought forward bold technologies and built
              exceptional businesses. Our proven expertise in the worlds of material science,
              microelectronics, miniaturization, software, and data science have been melded
              together to form an extraordinary team—one that is ready to revolutionize medical
              imaging.
            </p>
            <CTA
              ascope="CTAS"
              adata="MISC.OURPEOPLE"
              ready={ready}
              className={Styles.cta}
              color={color}
              to={URLS.OUR_PEOPLE}
            >
              See More
            </CTA>
          </div>
          <div className={Styles.featuredPerson}>
            <PersonCard person={people[0]} />
          </div>
        </div>
        <div className={Styles.rightHalf}>
          <div className={Styles.leftQuarter}>
            <PersonCard person={people[1]} />
          </div>
          <div className={Styles.rightQuarter}>
            <PersonCard person={people[2]} />
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default OurPeople
